class TimetableFunction {
    instructorId: number;
    setId: number;
    functionId: number;
    sectionId: number;

    constructor(instructorId: number, functionId: number, setId: number, sectionId: number) {
        this.instructorId = instructorId;
        this.functionId = functionId;
        this.setId = setId;
        this.sectionId = sectionId;
    }
}

export default TimetableFunction;
